import { ShieldCheck, ShieldAlert, ShieldQuestion } from "lucide-react";

export const TrustBadge = ({ trust, compact = false }) => {
  if (!trust) return null;
  const level = trust.level || "New";
  const cfg = {
    Trusted: { color: "text-green-400", bg: "bg-green-500/10 border-green-500/30", Icon: ShieldCheck },
    Building: { color: "text-amber-400", bg: "bg-amber-500/10 border-amber-500/30", Icon: ShieldQuestion },
    New: { color: "text-slate-400", bg: "bg-slate-700/40 border-white/10", Icon: ShieldAlert },
  }[level];
  const { Icon } = cfg;

  if (compact) {
    return (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold border ${cfg.bg} ${cfg.color}`}>
        <Icon className="h-3.5 w-3.5" /> {level} · {trust.score}
      </span>
    );
  }

  return (
    <div className={`rounded-xl border p-4 ${cfg.bg}`} data-testid="trust-badge">
      <div className="flex items-center gap-2.5">
        <Icon className={`h-6 w-6 ${cfg.color}`} />
        <div>
          <div className="flex items-center gap-2">
            <span className={`font-bold ${cfg.color}`}>{level} hustler</span>
            <span className="font-mono text-sm text-slate-400">trust {trust.score}/100</span>
          </div>
          <div className="flex flex-wrap gap-1.5 mt-1.5">
            {(trust.badges || []).map((b, i) => (
              <span key={i} className="text-[11px] px-2 py-0.5 rounded-full bg-black/30 text-slate-300 border border-white/10">
                {b}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
